var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"panel"},[_c('div',{staticClass:"fading"},[_c('h1',[_vm._v("Thank you")]),_vm._v(" "),(_vm.text)?_c('div',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.text.thank_you)}}):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }